const caches = new WeakMap();
/** Logout must clear private snapshots even after the last modal observer unmounts. */
export function bindOnrampCache(client, cache) {
    let registered = caches.get(client);
    if (!registered) {
        registered = new WeakSet();
        caches.set(client, registered);
    }
    if (registered.has(cache))
        return;
    registered.add(cache);
    client.onDispose(() => {
        cache.removeQueries({ queryKey: ['onramp', client.cacheKey] });
    });
}
